import React, { Component } from "react";
import "./CreateModal.styles.scss";
import EscapeOutside from "react-escape-outside";
import axios from "axios";
// import { css } from "@emotion/core"
import BounceLoader from "react-spinners/BounceLoader";
import AxiosClient from "../../../../../../Network/AxiosClient";

// import fse_img from "./_image/person.svg"
import pic from "./_image/picture.svg";
import close_green_corner from "./_image/close_green_corner.svg";
import close_button from "./_image/close_button.svg";
import Dropdown from "../../../MDOTable/components/CreateModal/CustomDropdown/Dropdown";
import { verificationTypes } from "../../../../../Shared/GlobalConfigs";
// import MomentUtils from "@date-io/moment";
import DateFnsUtils from "@date-io/date-fns";
//import moment from "moment";
import { addDays, format } from "date-fns";
import Dialog from "@material-ui/core/Dialog";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
const empolyee_types = [
  { id: "office_manager", name: "Office manager" },
  { id: "peon", name: "Peon" },
  { id: "security_guard", name: "Security guard" },
  { id: "cleaner", name: "Cleaner" },
];

const weekdays = [
  {
    id: "101",
    name: "Sunday",
  },
  {
    id: "102",
    name: "Monday",
  },
  {
    id: "103",
    name: "Tuesday",
  },
  {
    id: "104",
    name: "Wednesday",
  },
  {
    id: "105",
    name: "Thursday",
  },
  {
    id: "106",
    name: "Friday",
  },
  {
    id: "107",
    name: "Saturday",
  },
];

const Modal = ({ handleClose, show, children }) => {
  return (
    <div className={show ? "modal display-block" : "modal display-none"}>
      <EscapeOutside onEscapeOutside={handleClose}>
        <div className="wrapper-modal">
          <section className="modal-main">{children}</section>
        </div>
      </EscapeOutside>
    </div>
  );
};

class CreateModal extends Component {
  state = {
    image:
      "https://png.pngitem.com/pimgs/s/506-5067022_sweet-shap-profile-placeholder-hd-png-download.png",
    image_object: null,
    agencies: [],
    selected_option: [],
    leave_day: null,
    type: null,
    loading: false,
    name: "",
    contact_number: "",
    personal_number: "",
    nid: "",
    clear: false,
    showError: false,
    showSuccess: false,
    joining_date: new Date(),
    birth_date: new Date(),
    verification_type: null,
  };
  componentDidMount() {
    this.loadAgencies();
  }

  handleChange = (selected_option) => {
    this.setState({ selected_option });
  };

  handleClick = () => {
    document.getElementById("uploadimage").click();
  };

  handleSelectLeave = (leave) => {
    this.setState({ leave_day: leave.name, leave_day_id: leave.id });
  };

  handleType = (type) => this.setState({ type: type.id });
  handleVerificationType = (type) =>
    this.setState({ verification_type: type.id });

  handleImageChange = (event) => {
    const fileUploaded = event.target.files[0];

    this.setState({
      image: URL.createObjectURL(fileUploaded),
      image_object: fileUploaded,
    });
  };

  handleDateChange = (date) => {
    this.setState({
      joining_date: date,
    });
  };

  handleBirthDateChange = (date) => {
    this.setState({
      birth_date: date,
    });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  loadAgencies = () => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/agency`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        this.setState({
          agencies: res.data.data,
        });
      })
      .catch((err) => console.log(err));
  };

  handleFormSubmit = () => {
    const fd = new FormData();
    const {
      name,
      contact_number,
      selected_option,
      image_object,
      leave_day,
      joining_date,
      type,
      verification_type,
      nid,
      birth_date,
      personal_number,
    } = this.state;

    if (
      name &&
      contact_number &&
      selected_option &&
      image_object &&
      leave_day &&
      joining_date &&
      type &&
      birth_date &&
      verification_type &&
      nid
    ) {
      this.setState({ loading: true });
      fd.append("image", image_object);
      fd.append("name", name);
      fd.append("contact_number", contact_number);
      fd.append("verification_type", verification_type);
      fd.append("nid", nid);
      fd.append("reporting_agency", selected_option.id);
      fd.append("leave_day", leave_day);
      fd.append("type", type);
      if (personal_number) fd.append("personal_number", personal_number);
      fd.append(
        "joining_date",
        //moment(joining_date).format("yyyy-MM-dd").toString()
        format(new Date(joining_date), "yyyy-MM-dd")
      );
      fd.append(
        "birth_date",
        //moment(joining_date).format("yyyy-MM-dd").toString()
        format(new Date(birth_date), "yyyy-MM-dd")
      );

      AxiosClient.post(
        `${process.env.REACT_APP_API_URL}/api/admin_panel/v1/office-employee`,
        fd,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
        .then((res) => {
          //console.log(res);
          this.setState(
            { loading: false, showError: false, showSuccess: true },
            () => this.close_clear()
          );
          this.props.handleSubmit();
          this.props.handleHide();
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loading: false, showError: true });
        });
    } else {
      this.setState({ showError: true });
    }
  };

  close_clear = () => {
    this.props.handleHide();
    this.setState(
      {
        name: "",
        image:
          "https://png.pngitem.com/pimgs/s/506-5067022_sweet-shap-profile-placeholder-hd-png-download.png",
        image_object: null,
        selected_option: {},
        loading: false,
        contact_number: "",
        clear: true,
        showError: false,
        personal_number: "",
      },
      () => {
        this.props.reset_toggle();
      }
    );
    //console.log(`closeclear called`);
  };

  render() {
    const {
      name,
      contact_number,
      selected_option,
      image_object,
      supervisorType,
    } = this.state;
    const isSuperUser =
      JSON.parse(localStorage.getItem("currUserType")) === "bkash-super-user"
        ? true
        : false;
    return (
      <section className="fsecreate-section">
        {/* <h3 className="ex-title">Modal Type: 1</h3> */}

        <Modal show={this.props.show} handleClose={this.hideModal}>
          <div className="modal-header">
            <div className="headline">
              <div className="main-headline">Create Back-office employee</div>
              <div className="sub-headline">
                Fill in the details and press Submit
              </div>
            </div>
            <div className="close-button-corner" onClick={this.close_clear}>
              <img className="corner" src={close_green_corner} alt="close" />
              <img className="cross" src={close_button} alt="close" />
              {/* <button className="button--close" onClick={this.props.handleHide}>
                X
              </button> */}
            </div>
          </div>
          <div className="modal-body">
            <div className="basic">
              <div className="image">
                <img src={this.state.image} alt="basic" />
                <div className="tag" onClick={this.handleClick}>
                  <img src={pic} alt="upload" />
                  <input
                    type="file"
                    id="uploadimage"
                    onChange={this.handleImageChange}
                    style={{ display: "none" }}
                  />
                </div>
              </div>
              <div className="instructions">
                <p>
                  Upload a clear picture of the FSE. Picture must be a minimum
                  of 400x400 px and maximum of 1 mb.
                </p>
              </div>
            </div>
          </div>

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <form>
              <div className="group">
                <input
                  value={this.state.name}
                  onChange={(e) => {
                    e.preventDefault();
                    this.setState({
                      name: e.target.value,
                    });
                  }}
                  // placeholder={this.props.name}
                  type="text"
                  required="required"
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>Full Name</label>
              </div>
              <div className="group">
                <div className="tel-placeholder">+88</div>
                <input
                  value={this.state.contact_number}
                  onChange={(e) => {
                    var reg = /^-?\d*\.?\d*$/;
                    if (!reg.test(e.target.value)) return;
                    e.preventDefault();
                    this.setState({
                      contact_number: e.target.value,
                    });
                  }}
                  // placeholder={this.props.name}
                  type={"tel"}
                  required="required"
                  maxLength="11"
                  style={{ textIndent: 32 }}
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label className="input-tel-label">Phone</label>
              </div>
              <div className="group">
                <div className="tel-placeholder">+88</div>
                <input
                  value={this.state.personal_number}
                  onChange={(e) => {
                    var reg = /^-?\d*\.?\d*$/;
                    if (!reg.test(e.target.value)) return;
                    e.preventDefault();
                    this.setState({
                      personal_number: e.target.value,
                    });
                  }}
                  // placeholder={this.props.name}
                  type={"tel"}
                  required="required"
                  maxLength="11"
                  style={{ textIndent: 32 }}
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label className="input-tel-label">Personal bKash number</label>
              </div>
              <div className="group">
                <Dropdown
                  title="Employee type"
                  items={empolyee_types}
                  searchable={false}
                  onChange={this.handleType}
                  reset={this.props.reset}
                />
              </div>
              <div className="group">
                {" "}
                <Dropdown
                  className="dd-cmdo"
                  title="Agency"
                  items={this.state.agencies}
                  searchable
                  onChange={this.handleChange}
                  reset={this.props.reset}
                />
              </div>
              <div className="group">
                <Dropdown
                  className="dd-cmdo"
                  title="Leave Day"
                  items={weekdays}
                  searchable
                  onChange={this.handleSelectLeave}
                  reset={this.props.reset}
                />
              </div>

              <div className="group">
                {" "}
                <Dropdown
                  className="dd-cmdo"
                  title="Verification type"
                  items={verificationTypes}
                  searchable
                  onChange={this.handleVerificationType}
                  reset={this.props.reset}
                />
              </div>

              <div className="group">
                <input
                  value={this.state.nid}
                  onChange={(e) => {
                    e.preventDefault();
                    this.setState({
                      nid: e.target.value,
                    });
                  }}
                  // placeholder={this.props.name}
                  type="text"
                  required="required"
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>Verification number</label>
              </div>

              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Birth Date"
                format="dd/MM/yyyy"
                value={this.state.birth_date}
                InputAdornmentProps={{ position: "start" }}
                onChange={(date) => this.handleBirthDateChange(date)}
                style={{
                  width: "100%",
                  margin: "10px auto",
                }}
              />
              <KeyboardDatePicker
                autoOk
                variant="inline"
                inputVariant="outlined"
                label="Joining Date"
                format="dd/MM/yyyy"
                value={this.state.joining_date}
                InputAdornmentProps={{ position: "start" }}
                maxDate={isSuperUser ? addDays(new Date(), 365) : new Date()}
                onChange={(date) => {
                  const c = window.confirm(
                    `Are you sure about this joining date ${new Date(
                      date
                    ).toDateString()} ? `
                  );
                  if (c === true) this.handleDateChange(date);
                }}
                style={{
                  width: "100%",
                  margin: "10px auto",
                }}
              />
            </form>
          </MuiPickersUtilsProvider>

          <div className="footer">
            {this.state.showError && (
              <div className="alert-box">
                <p>
                  Missing fields or Whitelisting Number already exists. Please
                  fill the form out properly.
                </p>
              </div>
            )}
            {this.state.showSuccess && (
              <div className="success-box">
                <p>New FSE created successfully</p>
              </div>
            )}
            <BounceLoader
              className="loader"
              color={"#e2136e"}
              size={20}
              loading={this.state.loading}
            />
            <button className="button--cancel" onClick={this.close_clear}>
              {" "}
              Cancel{" "}
            </button>
            <button
              className={true ? `button--save` : `button--save--disabled`}
              disabled={this.state.loading}
              onClick={this.handleFormSubmit}
            >
              {" "}
              Save{" "}
            </button>
          </div>
        </Modal>
      </section>
    );
  }
}

export default CreateModal;
